import React from 'react';
import { X, AlertCircle } from 'lucide-react';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  itemName, 
  itemType, 
  isDarkMode 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" 
        onClick={onClose} 
      />
      
      {/* Modal Card */}
      <div 
        className={`relative w-full max-w-sm p-10 shadow-2xl rounded-2xl transform transition-all animate-in fade-in zoom-in-95 duration-300 ${
          isDarkMode ? 'bg-[#141211] border border-stone-800' : 'bg-white'
        }`}
      >
        <button 
          onClick={onClose} 
          className="absolute top-6 right-6 p-2 opacity-30 hover:opacity-100 transition-opacity"
        >
          <X size={20} className={isDarkMode ? 'text-white' : 'text-stone-900'} />
        </button>

        <div className="text-center space-y-6">
          <div className={`w-16 h-16 mx-auto rounded-full flex items-center justify-center ${
            isDarkMode ? 'bg-red-500/10' : 'bg-red-50'
          }`}>
            <AlertCircle size={32} className="text-red-500" />
          </div>

          <div className="space-y-2">
            <h3 className={`text-2xl font-serif font-bold ${isDarkMode ? 'text-white' : 'text-stone-900'}`}>
              Delete {itemType === 'post' ? 'Reflection' : 'Archive Entry'}
            </h3>
            <p className={`text-sm leading-relaxed px-4 opacity-50 ${isDarkMode ? 'text-stone-400' : 'text-stone-500'}`}>
              Are you sure you want to remove <span className="font-bold opacity-100">"{itemName}"</span>? This action is permanent.
            </p>
          </div>

          <div className="flex flex-col gap-3 pt-4">
            <button 
              onClick={onConfirm}
              className="w-full py-4 rounded-full bg-red-600 text-white text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-red-700 transition-colors shadow-lg"
            >
              Delete Forever
            </button>
            <button 
              onClick={onClose}
              className={`w-full py-4 rounded-full border text-[10px] font-bold uppercase tracking-[0.2em] transition-all ${
                isDarkMode 
                  ? 'border-stone-800 text-stone-400 hover:bg-stone-800' 
                  : 'border-stone-100 text-stone-500 hover:bg-stone-50'
              }`}
            >
              Keep it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;